<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center z-20"
  >
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
    </div>

    <div
      class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full relative"
    >
      <div
        v-if="loading"
        class="absolute flex justify-center items-center bg-gray-500 opacity-50 w-full h-full z-30"
      >
        <font-awesome-icon class="text-black text-2xl" icon="spinner" spin />
      </div>
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          <div
            class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
          >
            <font-awesome-icon :icon="['far', 'exclamation-triangle']" class="text-red-600" />
          </div>
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 class="text-lg leading-6 font-medium text-gray-900">Tickets stornieren</h3>
            <div class="mt-2">
              <p
                class="text-sm leading-5 text-gray-500"
              >Bitte beachten Sie, dass eine Stornierung nicht rückgängig gemacht werden kann.</p>
            </div>

            <div class="mt-4 max-h-56 overflow-y-auto">
              <div v-for="ticket in filteredTickets" :key="ticket.id" class="mt-4">
                <div class="relative flex items-start">
                  <div class="absolute flex items-center h-5">
                    <input
                      :id="ticket.id"
                      v-model="selected"
                      :value="ticket.id"
                      type="checkbox"
                      class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                    />
                  </div>
                  <div class="pl-6 text-sm leading-5">
                    <label :for="ticket.id" class="font-medium text-gray-700">{{ticket.type.title}}</label>
                    <p class="text-gray-500">{{ticket.code}} &middot; {{ticket.price | price}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            :disabled="selected.length <= 0"
            type="button"
            @click="refund"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 leading-6 font-medium text-white shadow-sm focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            :class="selected.length <= 0 ? 'bg-red-300 cursor-not-allowed' : 'bg-red-600 hover:bg-red-500'"
          >{{totalRefund | price}} zurückerstatten</button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button
            @click="close"
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          >Abbrechen</button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import orderClient from "@/api/merchant/orders";

export default {
  props: ["order"],
  data() {
    return {
      selected: [],
      loading: false
    };
  },
  filters: {
    price(value) {
      var formatter = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR"
      });

      return formatter.format(value / 100);
    }
  },
  computed: {
    totalRefund() {
      return _(this.order.tickets)
        .keyBy("id")
        .at(this.selected)
        .filter()
        .sumBy("price");
    },
    filteredTickets() {
      return _.filter(this.order.tickets, {
        refunded: false,
        refundable: true
      });
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    refund() {
      this.loading = true;

      orderClient
        .refund(this.order.id, { tickets: this.selected })
        .then(response => {
          this.loading = false;

          this.$toasted.show("Tickets wurden storniert.", {
            position: "bottom-right",
            theme: "lt",
            type: "success",
            duration: 5000
          });

          this.$emit("refundSuccesfull");
        })
        .catch(error => {
          this.$toasted.show(
            "Tickets konnten NICHT storniert werden. Bitte kontaktieren Sie den Support.",
            {
              position: "bottom-right",
              theme: "lt",
              type: "error",
              duration: 10000
            }
          );
        });
    }
  }
};
</script>